import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import { Counter } from '@vk-hr-tek/ui/Counter';

import { SearchLabelItem } from '../SearchInput.types';

interface SearchOptionLabelProps {
  option: SearchLabelItem;
}

const LIMIT_TO_SHOW = 999;

export const SearchOptionLabel = ({ option }: SearchOptionLabelProps) => {
  return (
    <Box
      height={26}
      width="100%"
      px="8"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Typography variant="subtitle2" color="text.light.tertirary">
        {option.label}
      </Typography>
      <Tooltip
        placement="left"
        title="Количество найденных результатов похожих на ваш запрос. Уточните поиск, чтобы увидеть наиболее подходящие варианты"
      >
        <Box>
          <Counter
            counter={
              option.total > LIMIT_TO_SHOW ? `${LIMIT_TO_SHOW}+` : option.total
            }
            color="blue"
            backgroundColor="lightBlue"
          />
        </Box>
      </Tooltip>
    </Box>
  );
};
